import {AssessmentId, FindingId, FindingIdPair} from "platformed-client/types";
import {platformedClient} from "..";
import {invalidateQueries, q} from "../../state";

export async function load(findingIds: FindingIdPair[]) {
  return await platformedClient.internalRequest("post", "/region/{region}/api/tprm/findings/load", {body: findingIds});
}

export async function delete_(assessmentId: AssessmentId, findingId: FindingId) {
  await platformedClient.internalRequest("delete", "/region/{region}/api/tprm/findings/{finding_id}", {
    path: {finding_id: findingId},
  });

  await invalidateQueries([
    q.tprm.assessmentFindings.filter(assessmentId),
    q.tprm.finding.filter(assessmentId, findingId),
  ]);
}

export async function updateIncludeInternal(
  assessmentId: AssessmentId,
  findingId: FindingId,
  includeInternal: boolean,
) {
  await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/findings/{finding_id}/update_include_internal",
    {path: {finding_id: findingId}, body: includeInternal},
  );

  await invalidateQueries([
    q.tprm.assessmentFindings.filter(assessmentId),
    q.tprm.finding.filter(assessmentId, findingId),
  ]);
}

export async function updateIncludeClientFacing(
  assessmentId: AssessmentId,
  findingId: FindingId,
  includeClientFacing: boolean,
) {
  await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/findings/{finding_id}/update_include_client_facing",
    {path: {finding_id: findingId}, body: includeClientFacing},
  );

  await invalidateQueries([
    q.tprm.assessmentFindings.filter(assessmentId),
    q.tprm.finding.filter(assessmentId, findingId),
  ]);
}
